import React, {useEffect, useRef, useState} from 'react'
import "./../../utils/Style/pages/Banktransfers.scss";
import TillsInput from "../../components/Branch/TillsInput";
import SupervisorsInput from "../../components/Branch/SupervisorsInput";
import useCommonAPI from "../../api/CommonAPI";
import AddressInput from "../../components/Branch/AddressInput";
import { useDispatch } from "react-redux";
import { setActionPayload, setActionType } from "../../features/authorizationSlice";
import { ACTION_TYPES } from "../../app/actionTypes";
import { useLocation, useOutletContext } from "react-router-dom";
import useBranchAPI from "../../api/branchAPI";
import HeaderComponent from "../../components/HeaderComponent";


function EditBranchTemplate() {
    const { getAllRegions, regions } = useCommonAPI();
    const { GetBranchDetails, branchDetails } = useBranchAPI();
    const locationNav = useLocation();
    const { data } = locationNav.state;

    useEffect(() => {
        GetBranchDetails(data.BranchID);
    }, [])


    const [portalBranchDTO, setPortalBranchDTO] = useState({
        "Name": "",
        "MerchantID": 0,
        "Description": "",
        "RegionID": 0,
        "MobileNo": "",
        "PhoneNo": "",
        "Longitude": 0,
        "Latitude": 0,
        "isVisible": null,
        "isOnline": false,
        "BranchEmployee": [],
        "tillReferences": []
    });
    const [errors, setErrors] = useState({});


    const validateForm = () => {
        let isValid = true;
        const newErrors = {};

        if (!portalBranchDTO.Name) {
            newErrors.Name = "Branch Name is required.";
            isValid = false;
        }

        if (!portalBranchDTO.MerchantID) {
            newErrors.MerchantID = "Merchant is required.";
            isValid = false;
        }

        if (!portalBranchDTO.isOnline && !portalBranchDTO.RegionID) {
            newErrors.RegionID = "Region is required.";
            isValid = false;
        }

        if (!portalBranchDTO.isOnline && !portalBranchDTO.Description) {
            newErrors.Description = "Address is required.";
            isValid = false;
        }

        if (!portalBranchDTO.MobileNo) {
            newErrors.MobileNo = "Mobile Number is required.";
            isValid = false;
        }

        const regex = /^\+?\d{7,}$/
        if (portalBranchDTO.MobileNo && !regex.test(portalBranchDTO.MobileNo)) {
            newErrors.MobileNo = "Mobile Number format is incorrect.";
            isValid = false;
        }

        if (portalBranchDTO.PhoneNo && !regex.test(portalBranchDTO.PhoneNo)) {
            newErrors.PhoneNo = "Phone Number format is incorrect.";
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    useEffect(() => {
        setPortalBranchDTO((prevState) => ({
            "Name": branchDetails.Name,
            "MerchantID": branchDetails.MerchantID,
            "isOnline": branchDetails.isOnline,
            "Description": branchDetails.Description,
            "RegionID": branchDetails.Region !== undefined ? branchDetails.Region.value : "0",
            "MobileNo": branchDetails.MobileNo,
            "PhoneNo": branchDetails.PhoneNo,
            "Longitude": branchDetails.Longitude,
            "Latitude": branchDetails.Latitude,
            "isVisible": branchDetails.isVisible,
            "BranchEmployee": (branchDetails.BranchEmployee !== undefined && branchDetails.BranchEmployee.length !== 0) ? branchDetails.BranchEmployee : [{
                EmployeeID: '-1',
                PhoneNo: '',
            }],
            "tillReferences": (branchDetails.tillReferences !== undefined && branchDetails.tillReferences.length !== 0) ? branchDetails.tillReferences : [{
                ReferenceNo: '',
                TypePOSValue: ''
            }]
        })
        );
        setSupervisors((branchDetails.BranchEmployee !== undefined && branchDetails.BranchEmployee.length !== 0) ? branchDetails.BranchEmployee : [{
            EmployeeID: '-1',
            PhoneNo: ''
        }])
        setTills((branchDetails.tillReferences !== undefined && branchDetails.tillReferences.length !== 0) ? branchDetails.tillReferences : [{
            ReferenceNo: '',
            TypePOSValue: ''
        }])
    }, [branchDetails]);

    const [supervisors, setSupervisors] = useState([{ EmployeeID: '-1', Name: '' }]);
    const [tills, setTills] = useState([{ ReferenceNo: '', TypePOSValue: '', TypePOSLabel: '' }]);

    const handleRadioChange = (event) => {
        const { id } = event.target;
        setPortalBranchDTO((prevState) => ({
            ...prevState,
            isVisible: id === "Yes",
        }))
    };

    const [onOpenQrAfterGenerate] = useOutletContext();
    const dispatch = useDispatch();

    useEffect(() => {
        setPortalBranchDTO((prevState) => ({
            ...prevState,
            "BranchEmployee": supervisors
                .filter((supervisor) => !(supervisor.EmployeeID === '-1' && supervisor?.Name?.trim() === ''))
                .map((supervisor) => ({
                    "PhoneNo": supervisor.PhoneNumber,
                    ...supervisor,
                })),
            "tillReferences": tills
                .filter((till) => !(till.ReferenceNo?.trim() === ''))
        }));
    }, [tills, supervisors]);

    const containerRef = useRef(null);
    const handleSubmit = (event) => {
        if (validateForm()) {
            const payload = {
                portalBranchDTO: portalBranchDTO,
                "BranchID": data.BranchID,
            }
            event.preventDefault();

            dispatch(setActionType(ACTION_TYPES.EDIT_BRANCH));
            dispatch(setActionPayload(payload));

            onOpenQrAfterGenerate();
        }else {
            const container = containerRef.current;
            if (container) {
                container.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        }

    }
    useEffect(() => {
        getAllRegions();
    }, []);


    return (
        <>
            <HeaderComponent title="Edit Branches" />
            <div className="BranchesPage">
                <div className="container-fluid Branchescontainer">
                    <div className="col-lg-12 col-sm-12">
                        <div id="NewBranchesTemplate"  ref={containerRef} style={{ height: '82vh', overflowY: 'auto', overflowX: 'hidden' }}>
                            <div className="title">GENERAL INFORMATION</div>
                            <div className="row mb-3">
                                <div className="col-lg-3 col-md-6 col-sm-12">
                                    <div className="row component">
                                        <div className="col-lg-12 col-md-12 col-sm-12 subTitle">Branch</div>
                                        <div className="col-lg-12 col-md-12 col-sm-12 desc">
                                            <input
                                                placeholder="Branch Name"
                                                value={portalBranchDTO.Name}
                                                onChange={(e) => setPortalBranchDTO((prevState) => ({
                                                    ...prevState,
                                                    Name: e.target.value,
                                                }))}
                                            />
                                            {errors.Name && (
                                                <span className="error">{errors.Name}</span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-12">
                                    <div className="row component">
                                        <div className="col-lg-12 col-md-12 col-sm-12 subTitle">Payment Options</div>
                                        <div className="col-lg-12 col-md-12 col-sm-12 desc">
                                            <select
                                                className="ddselect"
                                                name="account"
                                                id="account"
                                                placeholder="Select"
                                                disabled={true}
                                            >
                                                <option value="pos" selected={!portalBranchDTO.isOnline}>POS</option>
                                                <option value="online" selected={portalBranchDTO.isOnline}>Online</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-12 col-sm-12">
                                    <div className="row component">
                                        <div className="col-lg-12 col-md-12 col-sm-12 subTitle">Show to Customers On Suyool</div>
                                        <div className="col-lg-12 col-md-12 col-sm-12 desc">
                                            <div className="radio">
                                                <div className="radioCont">
                                                    <label htmlFor="Yes">Yes</label>
                                                    <input
                                                        type="radio"
                                                        id="Yes"
                                                        checked={portalBranchDTO.isVisible}
                                                        onChange={handleRadioChange}
                                                        name="Customers"
                                                    />
                                                </div>
                                                <div className="radioCont">
                                                    <label htmlFor="No">No</label>
                                                    <input
                                                        type="radio"
                                                        id="No"
                                                        checked={!portalBranchDTO.isVisible}
                                                        name="Customers"
                                                        onChange={handleRadioChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row mb-3">
                                {/*{GetMerchantsInfoList && <MerchantInput portalBranchDTO={portalBranchDTO} setPortalBranchDTO={setPortalBranchDTO} options={GetMerchantsInfoList?.LegalEntityMerchantsInfoList} type="edit"/>}*/}
                                <div className="col-lg-3 col-md-6 col-sm-12">
                                    <div className="row component">
                                        <div className="col-lg-12 subTitle">Merchant</div>
                                        <div className="col-lg-12 desc">
                                            <input
                                                value={branchDetails?.MerchantName}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-12">
                                    <div className="row component">
                                        <div className="col-lg-12 subTitle">Mobile Number</div>
                                        <div className="col-lg-12 desc">
                                            <input
                                                placeholder="Mobile Number"
                                                defaultValue={portalBranchDTO.MobileNo}
                                                onChange={(e) => setPortalBranchDTO((prevState) => ({
                                                    ...prevState,
                                                    MobileNo: e.target.value,
                                                }))}
                                            />
                                            {errors.MobileNo && (
                                                <span className="error">{errors.MobileNo}</span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-12">
                                    <div className="row component">
                                        <div className="col-lg-12 subTitle">Phone Number</div>
                                        <div className="col-lg-12 desc">
                                            <input
                                                placeholder="Phone Number"
                                                defaultValue={portalBranchDTO.PhoneNo}
                                                onChange={(e) => setPortalBranchDTO((prevState) => ({
                                                    ...prevState,
                                                    PhoneNo: e.target.value,
                                                }))}
                                            />
                                            {errors.PhoneNo && (
                                                <span className="error">{errors.PhoneNo}</span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {!portalBranchDTO.isOnline ? (
                                <>
                                    <div className="row mb-3">
                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                            <div className="row component">
                                                <div className="col-lg-12 subTitle">Region</div>
                                                <div className="col-lg-12 desc">
                                                    <select
                                                        className="ddselect"
                                                        name="account"
                                                        id="account"
                                                        placeholder="Select"
                                                        defaultValue={portalBranchDTO.RegionID}
                                                        onChange={(e) => setPortalBranchDTO((prevState) => ({
                                                            ...prevState,
                                                            RegionID: e.target.value,
                                                        }))}
                                                    >
                                                        {regions.map(({ label, value }) => (
                                                            <option
                                                                key={value}
                                                                value={value}
                                                                selected={value === portalBranchDTO.RegionID}
                                                            >{label}</option>
                                                        ))}
                                                    </select>
                                                    {errors.RegionID && (
                                                        <span className="error">{errors.RegionID}</span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className='col-lg-5 col-md-9 col-sm-12 map'>
                                            <AddressInput
                                                portalBranchDTO={portalBranchDTO}
                                                setPortalBranchDTO={setPortalBranchDTO}
                                            />

                                        </div>
                                    </div>

                                    <TillsInput tills={tills} setTills={setTills} />
                                </>
                            ) : (
                                <></>
                            )}

                            {
                                sessionStorage.getItem("EntityRole") !== "Supervisor" &&
                                <>
                                    <div className="title">EMPLOYEES ACCESS - SUPERVISOR</div>
                                    <SupervisorsInput supervisors={supervisors} setSupervisors={setSupervisors} />
                                </>
                            }


                            <div className='row'>
                                <div className='col-lg-4 col-sm-12'>
                                    <button className='newBrachSubmit' onClick={handleSubmit}>Submit</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>

    );
}

export default EditBranchTemplate;